class Nav
{
  constructor()
  {

    this.container = document.body.querySelector('.Header_nav')
    this.items = this.container.querySelectorAll('.Nav_item')
    this.burger = this.container.querySelector('#burger')
    this.accounts = this.container.querySelectorAll('.nav-account')
    this.links = this.container.querySelectorAll('a')
    

    this.openPanel = this.openPanel.bind(this)
    this.closePanel = this.closePanel.bind(this)
    this.resize = this.resize.bind(this)
    this.mobileNav = this.mobileNav.bind(this)
    this.toggleAccount = this.toggleAccount.bind(this)
    this.closeAccount = this.closeAccount.bind(this)
    this.switchNav = this.switchNav.bind(this)
    this.openMobileItem = this.openMobileItem.bind(this)
    this.defineHeight = this.defineHeight.bind(this)

    this.isMobile = false

    this.init()
  }

  init()
  {
    window.addEventListener('resize', this.resize )

    for (let i = 0; i < this.accounts.length; i++) {
      this.accounts[i].addEventListener('click', this.toggleAccount)
    }

    for (let i = 0; i < this.items.length; i++) {
      this.items[i].addEventListener('mouseenter', this.defineHeight)
    }
    
    this.resize()
    this.switchNav()
  }

  defineHeight(e)
  {
    if(this.isMobile) return

    let el = e.srcElement.querySelector('.Nav_sublist')
    if(el)
      document.body.querySelector('.Header_panel').style.height = el.offsetHeight + 60 + 'px'

  }

  switchNav()
  {
    var current = location.pathname

    for (let i = 1; i < this.links.length; i++) {
      let item = this.links[i]

      item.classList.remove('active')

      if ((item.getAttribute('href').indexOf(current) !== -1) && current != "/" && !item.getAttribute('href').indexOf("account"))
      {
          item.parentNode.parentNode.parentNode.classList.add('active')
      }
    }
  }

  resize()
  {
    if(window.innerWidth >= 1120)
    {
      this.isMobile = false
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].addEventListener('mouseover', this.openPanel)
        this.items[i].addEventListener('mouseleave', this.closePanel)
        this.items[i].removeEventListener('click', this.openMobileItem)
      }
      

      this.container.addEventListener('mouseleave', this.closePanel)

      this.burger.removeEventListener('click', this.mobileNav)

      this.container.classList.remove('is-mobile')
    }
    else
    {
      this.isMobile = true
      this.container.classList.add('is-mobile')

      this.burger.addEventListener('click', this.mobileNav)

      document.body.querySelector('.Header_panel').style.height = null

      for (let i = 0; i < this.items.length; i++) {
        this.items[i].removeEventListener('click', this.openPanel)
        this.items[i].removeEventListener('mouseleave', this.closePanel)
        this.items[i].removeEventListener('mouseenter', this.openPanel)
        this.items[i].addEventListener('click', this.openMobileItem)
      }

      this.container.removeEventListener('mouseleave', this.closePanel)
    }
  }

  toggleAccount(e)
  {
    let el = e.currentTarget.parentNode
    this.closePanel()

    el.querySelector('.Account_panel').classList.toggle('is-open')

    document.body.querySelector('#main').removeEventListener('click', this.closeAccount )

    if( el.querySelector('.Account_panel').classList.contains( 'is-open') )
    {
      document.body.querySelector('#main').addEventListener('click', this.closeAccount )
    }
  }

  closeAccount()
  {
    console.log( 'closeAccount' )
    document.body.querySelector('#main').removeEventListener('click', this.closeAccount )

    for (let i = 0; i < this.accounts.length; i++) {
      this.accounts[i].parentNode.querySelector('.Account_panel').classList.remove('is-open')
    }
  }

  openMobileItem(e)
  {
    let el = e.currentTarget

    for (let i = 0; i < this.items.length; i++) {
      if(this.items[i] != el)
        this.items[i].classList.remove('is-focus')
    }

    el.classList.toggle('is-focus')
  }

  mobileNav()
  {
    if(this.container.classList.contains('is-focus'))
    {
      this.closePanel()
      document.body.querySelector('#site-container').style.overflowY = "auto"
    }
    else
    {
      this.openPanel()
      document.body.querySelector('#site-container').style.overflowY = "hidden"
    }
  }

  openPanel()
  {
    clearTimeout(this.timeOut)
    this.container.classList.add('is-focus')
    
    for (let i = 0; i < this.accounts.length; i++) {
      this.accounts[i].parentNode.querySelector('.Account_panel').classList.remove('is-open')
    }
    
    this.burger.querySelector('i').classList.remove('fa-bars')
    this.burger.querySelector('i').classList.add('fa-times')
  }

  closePanel()
  {
    let delay = 0

    if(this.container.classList.contains('is-focus'))
      delay = 200

    this.timeOut = setTimeout(() => {
      this.container.classList.remove('is-focus')
    }, delay)

    this.burger.querySelector('i').classList.remove('fa-times')
    this.burger.querySelector('i').classList.add('fa-bars')
  }

  openAccountPanel()
  {
    console.log( 'openAccountPanel' , this.accounts )
    for (let i = 0; i < this.accounts.length; i++) {
      this.accounts[i].parentNode.querySelector('.Account_panel').classList.add('is-open')
    }

    setTimeout( () => {
      document.body.querySelector('#main').addEventListener('click', this.closeAccount )
    }, 500 );
  }
}

export default Nav;  


// WEBPACK FOOTER //
// ./src/js/partials/Nav.js